<template>
  <div v-if="shouldTrack && this.conversion">
    <img
      height="1"
      width="1"
      border="0"
      src="//conv.indeed.com/pagead/conv/1703618974414234/?script=0"
    >
  </div>
</template>
<script>
import { EventBus } from '@switchsystems/coactive-vue-lib';

const environment = process.env.VUE_APP_S3D_STAGE
  ? process.env.VUE_APP_S3D_STAGE
  : 'development';
const shouldTrack = environment === 'production'
  && process.env.NODE_ENV === 'production';

export default {
  name: 'IndeedTracker',
  mounted() {
    EventBus.$on('job-application/submitted', () => {
      // The localstorage item set by vue-cookie-law can be true/false or not exist.
      if (localStorage.getItem('cookie:accepted') !== 'true') return;
      this.conversion = true;
    });
  },
  beforeDestroy() {
    EventBus.$off('job-application/submitted');
  },
  data() {
    return {
      conversion: false,
      shouldTrack,
    };
  },
};
</script>
